import { DataResponseTransformed, TabletReactQueryState } from "./tabletReactQuery";

export interface PolygonZone {
  id: number;
  name: string;
  minutes_to_arrive: number;
}

export interface PolygonZonesModel extends DataResponseTransformed {
  rows: PolygonZone[];
}

export interface PolygonZonesState extends TabletReactQueryState {}

export const polygonZonesBuilder = {
  fromBackEnd: (polygonZone: any): PolygonZone => ({
    id: polygonZone.id,
    name: polygonZone.name,
    minutes_to_arrive: polygonZone.minutes_to_arrive,
  }),
};

